<template>
  <base-configurable-product>
    <div class="my10 price-wrapper">
      <product-price
        class=""
        :product="getCurrentProduct"
        :custom-options="getCurrentCustomOptions"
      />
    </div>
    <variant-selector class="mt15" />
    <div class="row my15">
      <div class="col-xs-12">
        <add-to-cart
          text="Add to cart"
          :product="getCurrentProduct"
          :disabled="isAddToCartDisabled"
          class="col-xs-12 uppercase py10 w-100"
        />
      </div>
      <div class="col-xs-12 align-center">
        <span class="cl-error h5 w-100" v-if="isAddToCartDisabled && !getIsStockInfoLoading">{{ $t('Brak produktu na stanie') }}</span>
        <span class="cl-error h5 w-100 flex mt5 center-xs" v-show="isAddingToCart"><Spinner /> {{ $t('Rezerwujemy ten produkt') }}</span>
      </div>
    </div>
  </base-configurable-product>
</template>

<script>
import { ProductMixin } from 'theme/components/core/blocks/Product-v2/ProductMixin.ts'
import BaseConfigurableProduct from './BaseConfigurableProduct.vue'
import VariantSelector from './components/VariantSelector.vue'
import AddToCart from 'theme/components/core/AddToCart.vue'
import Spinner from 'theme/components/core/Spinner.vue'
import ProductPrice from 'theme/components/core/ProductPrice.vue'
import { mapGetters } from 'vuex'
import { onlineHelper } from '@vue-storefront/core/helpers'

export default {
  name: 'BuyConfigurableProduct',
  components: {
    BaseConfigurableProduct,
    VariantSelector,
    AddToCart,
    Spinner,
    ProductPrice
  },
  mixins: [ProductMixin],
  computed: {
    ...mapGetters({
      getIsStockInfoLoading: 'stock/getIsStockInfoLoading',
      getMaxQuantity: 'stock/getMaxQuantity',
      getCurrentCustomOptions: 'product/getCurrentCustomOptions'
    }),
    isOnline () {
      return onlineHelper.isOnline
    },
    isAddToCartDisabled () {
      return this.getIsStockInfoLoading ||
        (this.isOnline && !this.getMaxQuantity)
    }
  },
  mounted () {
    this.$bus.$on('product-after-load', this.setProductCarierCode)
    this.setProductCarierCode()
  },
  beforeDestroy () {
    this.$bus.$off('product-after-load', this.setProductCarierCode)
  },
  methods: {
    setProductCarierCode () {
      this.$store.state.product.current.product_option.extension_attributes.carrier_code = 'any'
    },
  }
}
</script>

<style lang="scss" scoped>
.price-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
